export const flat = (arr: any[], d = 1): any[] =>
  typeof arr.flat === 'function' ? arr.flat(d) : flatDeep(arr, d)

export const flatDeep = (arr: any[], d = 1): any[] =>
  d > 0
    ? arr.reduce(
        (acc, val) =>
          acc.concat(Array.isArray(val) ? flatDeep(val, d - 1) : val),
        []
      )
    : arr.slice()

export const flattenObject = (
  obj: { [key: string]: any },
  roots: string[] = [],
  sep = '.'
): { [key: string]: any } =>
  Object.keys(obj).reduce(
    (memo, prop) =>
      Object.assign(
        {},
        memo,
        Object.prototype.toString.call(obj[prop]) === '[object Object]'
          ? flattenObject(obj[prop], roots.concat([prop]))
          : { [roots.concat([prop]).join(sep)]: obj[prop] }
      ),
    {}
  )
